import { gql } from '@apollo/client';

export const setStudioExactLocation = gql`
  mutation SetStudioExactLocation($input: SetStudioExactLocationInput!) {
    setStudioExactLocation(input: $input) {
      studioID
      streetAndNumber
      adressLine2
      city
      postcode
      country
      latitude
      longitude
    }
  }
`;

export const updateStudio = gql`mutation UpdateStudio(
  $input: UpdateStudioInput!
  $condition: ModelStudioConditionInput
) {
  updateStudio(input: $input, condition: $condition) {
    id
    StudioName
    images
    studioLocation
    city
    postcode
    country
    pricePerHour
    image
    description
    userID
    studioTypes
    tagValues
    studioSize
    numberOfPeople
    cancellationPolicy
    houseRules {
      smokingAllowed
      alcoholAllowed
      foodAllowed
      equipmentChangesAllowed
      pyrotechnicsAllowed
      glitterConfettiAllowed
      adultContentAllowed
      fogMachineAllowed
      customRules
    }
    approxLatitude
    approxLongitude
    locationLabel
    locationPrecision
    status
    minNumberOfHours
    pricingMode
    tieredPricing {
      minPersons
      maxPersons
      pricePerHour
    }
    packages {
      id
      name
      durationHours
      prices {
        minPersons
        maxPersons
        price
      }
    }
    discountRules {
      minHours
      discountType
      discountValue
    }
    weekendSurcharge {
      saturdayEnabled
      saturdaySurchargeType
      saturdaySurchargeValue
      sundayEnabled
      sundaySurchargeType
      sundaySurchargeValue
    }
    extraFees {
      id
      name
      amount
    }
    productionAreaSize
    amenities
    cancellationPolicy
    houseRules {
      smokingAllowed
      alcoholAllowed
      foodAllowed
      equipmentChangesAllowed
      pyrotechnicsAllowed
      glitterConfettiAllowed
      adultContentAllowed
      fogMachineAllowed
      customRules
    }
    tags {
      items {
        id
        studioId
        tagId
        tag {
          id
          name
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    averageRating
    createdAt
    updatedAt
    __typename
  }
}
`

export const archiveStudioSecure = gql`
  mutation ArchiveStudioSecure($input: ArchiveStudioInput!) {
    archiveStudioSecure(input: $input) {
      success
      message
      studioId
      status
      numberOfStudios
    }
  }
`;

export const deleteStudio = gql`mutation DeleteStudio(
  $input: DeleteStudioInput!
  $condition: ModelStudioConditionInput
) {
  deleteStudio(input: $input, condition: $condition) {
    id
    StudioName
    images
    studioLocation
    pricePerHour
    image
    description
    userID
    studioTypes
    tagValues
    studioSize
    numberOfPeople
    city
    postcode
    country
    approxLatitude
    approxLongitude
    locationLabel
    locationPrecision
    minNumberOfHours
    amenities
    tags {
      items {
        id
        studioId
        tagId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    equipment {
      items {
        id
        studioID
        category
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    availabilities {
      items {
        id
        studioID
        dayOfWeek
        startTime
        endTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    bookings {
      items {
        id
        studioID
        userID
        startDateTime
        endDateTime
        totalPrice
        status
        projectName
        companyName
        projectDescription
        paymentStatus
        paymentIntentID
        guestReviewed
        hostReviewed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    blockedTimes {
      items {
        id
        studioID
        title
        startDateTime
        endDateTime
        isFullDay
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    wishListStudios {
      items {
        id
        wishListID
        studioID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    chatRooms {
      items {
        id
        name
        image
        lastMessageAt
        studioID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    averageRating
    reviewCount
    reviews {
      items {
        id
        rating
        content
        communicationRating
        reviewerId
        revieweeId
        studioId
        reviewType
        bookingId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`
